import React from "react";
import PropTypes from "prop-types";
import { Input as AntInput } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { UiInput } from "./Input.style";
/**
 * 文字輸入匡
 */

const Input = ({
  label,
  message,
  onChange,
  placeholder,
  value,
  icon,
  onKeyEnter,
  row = false,
  maxLength,
  disabled,
  className
}) => {
  return /*#__PURE__*/React.createElement(UiInput, {
    className: className,
    row: row
  }, label && /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement(AntInput, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    prefix: icon && /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, icon),
    allowClear: true,
    onPressEnter: onKeyEnter,
    maxLength: maxLength,
    disabled: disabled
  }), message && /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};

export const TextArea = ({
  label,
  message,
  onChange,
  placeholder,
  value,
  disabled
}) => {
  return /*#__PURE__*/React.createElement(UiInput, null, label && /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement(AntInput.TextArea, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    autoSize: {
      minRows: 3,
      maxRows: 5
    },
    allowClear: true,
    disabled: disabled
  }), message && /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};
export const Search = ({
  onChange,
  onSearch = () => {},
  placeholder,
  value,
  mode,
  disabled
}) => {
  return /*#__PURE__*/React.createElement(UiInput, {
    className: mode
  }, /*#__PURE__*/React.createElement(AntInput, {
    onChange: onChange,
    onSearch: onSearch,
    placeholder: placeholder,
    value: value,
    suffix: /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "search"),
    allowClear: true,
    disabled: disabled
  }));
};
export const Password = ({
  label,
  message,
  onChange,
  placeholder,
  value,
  disabled
}) => {
  return /*#__PURE__*/React.createElement(UiInput, null, label && /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement(AntInput.Password, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    prefix: /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "lock_outline"),
    iconRender: visible => visible ? /*#__PURE__*/React.createElement(EyeTwoTone, null) : /*#__PURE__*/React.createElement(EyeInvisibleOutlined, null),
    allowClear: true,
    disabled: disabled
  }), message && /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};
export default Input;
Input.propTypes = {
  label: PropTypes.string,
  message: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  icon: PropTypes.string,
  onKeyEnter: PropTypes.func,
  row: PropTypes.bool,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool
};
TextArea.propTypes = {
  label: PropTypes.string,
  message: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
Search.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  mode: PropTypes.oneOf(["default", "dark"]),
  disabled: PropTypes.bool
};
Password.propTypes = {
  label: PropTypes.string,
  message: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};